<template>
  <div class="flex flex-col items-start gap-4 tablet:flex-row tablet:items-center tablet:justify-between" data-testid="lead-archive-action">
    <p class="txt-label-s text-subtlest" data-testid="lead-archive-hint">{{ t('Leads.archive.hint') }}</p>
    <button
      type="button"
      class="btn-outline-neutral-xs w-fit shrink-0 whitespace-nowrap"
      :class="{ 'btn-disabled': loading }"
      :disabled="loading"
      data-testid="lead-archive-toggle"
      @click="onClick"
    >
      <ArchiveRestoreIcon v-if="archived" class="lucide-icon-s" />
      <ArchiveIcon v-else class="lucide-icon-s" />
      {{ archived ? t('Leads.archive.unarchiveAction') : t('Leads.archive.archiveAction') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { ArchiveIcon, ArchiveRestoreIcon } from '@ramp106/omrjs-core-ui/icons'
import { useI18n } from 'vue-i18n'

import { useLeadArchive } from '@/composables/useLeadArchive'

const props = defineProps<{
  leadId: string
  archived: boolean
}>()

const { t } = useI18n()
const { toggleArchive, loading } = useLeadArchive()

function onClick() {
  toggleArchive(props.leadId, props.archived, 'lead_detail')
}
</script>
